angular.module('gym.mobile_app').directive('mobileAppSettingsAccessRequests', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/access_requests.html.slim'),
    scope: {
      setTab: '&'
    },
    controller: ["$scope", "$rootScope", "$window", "$filter", "MobileApp", "Locations", "TableService", function($scope, $rootScope, $window, $filter, MobileApp, Locations, TableService) {
      $scope.pageParams = {};
      $scope.onSearch = _.debounce((function() {
        return $scope.accessRequestsTable.reload();
      }), 450);
      $scope.accessRequestsTable = TableService.init({
        count: 10,
        getData: function(resolve, $params, beforeLoad) {
          var query;
          $scope.isLoading = true;
          query = angular.extend({
            search: $scope.pageParams.search
          }, $params.url());
          beforeLoad(query);
          return MobileApp.all('access_requests').getList(query).then(function(data) {
            $params.total(data.meta.total);
            $scope.$emit('access_requests:pending_count:updated', data.length);
            $scope.isLoading = false;
            return resolve(data);
          });
        }
      });
      $rootScope.$on('access_requests:reload', function() {
        return $scope.accessRequestsTable.reload();
      });
      $scope.goToWebsiteSettings = function() {
        return $scope.setTab({
          tab: {
            name: 'website_settings'
          }
        });
      };
      $scope.contactType = function(contact) {
        return $filter('underscored')(contact.contact_type) + 's';
      };
      $scope.isMember = function(contact) {
        return $filter('underscored')(contact.contact_type) === 'member';
      };
      return $scope.remove = function(item) {
        if ($window.confirm("The selected access request will be removed. Are you sure?")) {
          return item.remove().then(function() {
            return $scope.accessRequestsTable.reload();
          });
        }
      };
    }]
  };
});
